import React from 'react';
import { FaHome, FaCalendarAlt, FaComments } from 'react-icons/fa';

export default function MobileBottomTabs({ value, onChange }) {
  const tab = String(value || 'home');
  const set = (v) => onChange?.(v);

  const btnClass = (active) => ([
    'flex-1 h-14 flex items-center justify-center cursor-pointer',
    active ? 'text-indigo-600' : 'text-gray-500'
  ].join(' '));

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 md:hidden pb-[env(safe-area-inset-bottom)]">
      <div className="max-w-6xl mx-auto flex">
        <button type="button" className={btnClass(tab === 'home')} onClick={() => set('home')} aria-label="Home">
          <FaHome />
        </button>
        <button type="button" className={btnClass(tab === 'calendar')} onClick={() => set('calendar')} aria-label="Calendar">
          <FaCalendarAlt />
        </button>
        <button type="button" className={btnClass(tab === 'chat')} onClick={() => set('chat')} aria-label="Chat">
          <FaComments />
        </button>
      </div>
    </div>
  );
}


